<ng-container [ngSwitch]="validationType">
  <app-message-danger
    *ngSwitchCase="'required'"
    [message]="'shared.field_is_required' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'email'"
    [message]="'shared.email_is_invalid' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'minlength'"
    [message]="'shared.min_length' | translate: { count: requiredLength }"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'user_not_found'"
    [message]="'forgot_password.no_user' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'passwordRepeat'"
    [message]="'shared.validation_password_repeat' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'emailAlreadyTaken'"
    [message]="'shared.email_already_taken' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'is_white_space'"
    [message]="'shared.this_field_is_invalid' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'white_space'"
    [message]="'shared.this_field_is_invalid' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'invalid_phone_number'"
    [message]="'shared.phone_error' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchCase="'wrongPasswordResetToken'"
    [message]="'shared.wrong_password_reset_token' | translate"
  ></app-message-danger>
  <app-message-danger
    *ngSwitchDefault
    [message]="'shared.default_validation' | translate"
  ></app-message-danger>
</ng-container>
